export const isEmpty = (value: any) =>
    !value || value.length < 1 || Object.keys(value).length === 0;

export const notEmpty = (value: any) => !isEmpty(value);

export const isBlank = (value: string | undefined | null) => !value || value.trim() === '' ;

export const notBlank = (value: string | undefined | null) => !isBlank(value);

export const getExternalUrl = (url: string) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'https://' + url;
    }

    return url ?? '';
};

export const openInNewTab = (url: string | undefined) => {
    if (!url) return;

    window.open(url, '_blank', 'noopener,noreferrer');
};
